import request from "../services/requestService";
import * as apiServices from "../services/apiServices";
import { CREATE_PROJECT_ACTION } from "../constant";
import { get } from "lodash";

export const getProjectPageInfoAction = (
  requestMethod = request,
  isEdit,
  projectId
) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.CREATE_PROJECT_PAGE_INFO_START
    });
    return requestMethod(apiServices.getProjectPageInfo(isEdit, projectId))
      .then(resp => {
        const {
          data: { data }
        } = resp;
        dispatch({
          type: CREATE_PROJECT_ACTION.CREATE_PROJECT_PAGE_INFO_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CREATE_PROJECT_PAGE_INFO_FAILURE
        });
      });
  };
};

export const createProjectAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.CREATE_PROJECT_START
    });
    return requestMethod(apiServices.createProject(params))
      .then(response => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CREATE_PROJECT_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CREATE_PROJECT_FAILURE
        });
      });
  };
};

export const getBucketsWithMilestonesBySectorAction = (
  sectorId,
  makeEmpty,
  requestMethod = request
) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.GET_BUCKETS_WITH_MILESTONE_BY_SECTOR_START
    });
    return makeEmpty
      ? dispatch({
          type:
            CREATE_PROJECT_ACTION.GET_BUCKETS_WITH_MILESTONE_BY_SECTOR_SUCCESS,
          payload: []
        })
      : requestMethod(apiServices.getBucketsWithMilestonesBySector(sectorId))
          .then(response => {
            dispatch({
              type:
                CREATE_PROJECT_ACTION.GET_BUCKETS_WITH_MILESTONE_BY_SECTOR_SUCCESS,
              payload: response && response.data
            });
            return {
              data: get(response, "data.data"),
              status: get(response, "data.status"),
              message: get(response, "data.message")
            };
          })
          .catch(() => {
            dispatch({
              type:
                CREATE_PROJECT_ACTION.GET_BUCKETS_WITH_MILESTONE_BY_SECTOR_FAILURE
            });
          });
  };
};

export const getResponsibleAuthorityForMilestonesAction = (
  requestMethod = request
) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.GET_RESPONSIBLE_AUTHORITY_START
    });
    return requestMethod(apiServices.getResponsibleAuthorityMilestone())
      .then(response => {
        dispatch({
          type: CREATE_PROJECT_ACTION.GET_RESPONSIBLE_AUTHORITY_SUCCESS,
          payload: response && response.data
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.GET_RESPONSIBLE_AUTHORITY_FAILURE
        });
      });
  };
};

export const getValidateCinAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.GET_VALIDATE_CIN_START
    });
    return requestMethod(apiServices.getValidateCin(params))
      .then(resp => {
        dispatch({
          type: CREATE_PROJECT_ACTION.GET_VALIDATE_CIN_SUCCESS
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.GET_VALIDATE_CIN_FAILURE
        });
      });
  };
};

export const getSubSectorListAction = (requestMethod = request, params) => {
  return requestMethod(apiServices.getSubSectorsById(params))
    .then(response => {
      return {
        data: get(response, "data.data"),
        status: get(response, "data.status"),
        message: get(response, "data.message")
      };
    })
    .catch(() => {});
};

export const getSchemesListAction = (requestMethod = request, params) => {
  return requestMethod(apiServices.getSchemesList(params))
    .then(response => {
      return {
        data: get(response, "data.data"),
        status: get(response, "data.status"),
        message: get(response, "data.message")
      };
    })
    .catch(() => {});
};

export const getCostDistanceAction = (requestMethod = request, params) => {
  return requestMethod(apiServices.getCostDistance(params))
    .then(response => {
      return {
        data: get(response, "data.data"),
        status: get(response, "data.status"),
        message: get(response, "data.message")
      };
    })
    .catch(() => {});
};

export const getGroupCategoryIdAction = (requestMethod = request, id) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.GET_GROUP_BY_ID_START
    });
    return requestMethod(apiServices.getGroupById(id))
      .then(response => {
        dispatch({
          type: CREATE_PROJECT_ACTION.GET_GROUP_BY_ID_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.GET_GROUP_BY_ID_FAILURE
        });
      });
  };
};

export const getGroupsByCategoryAction = (requestMethod = request, id) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.GET_GROUP_BY_ID_START
    });
    return requestMethod(apiServices.getGroupsByCategory(id))
      .then(response => {
        dispatch({
          type: CREATE_PROJECT_ACTION.GET_GROUP_BY_ID_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.GET_GROUP_BY_ID_FAILURE
        });
      });
  };
};

export const getProjectDetailByIdAction = (requestMethod = request, id) => {
  return function() {
    return requestMethod(apiServices.getProjectDetail(id))
      .then(response => {
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {});
  };
};

export const editProjectAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.CREATE_PROJECT_START
    });
    return requestMethod(apiServices.editProject(params))
      .then(response => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CREATE_PROJECT_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CREATE_PROJECT_FAILURE
        });
      });
  };
};

export const editProjectMilestonesAction = (
  requestMethod = request,
  params
) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.EDIT_MILESTONE_START
    });
    return requestMethod(apiServices.editProjectMilestones(params))
      .then(response => {
        dispatch({
          type: CREATE_PROJECT_ACTION.EDIT_MILESTONE_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.EDIT_MILESTONE_FAILURE
        });
      });
  };
};

export const isDuplicateProjectAction = (requestMethod = request, data) => {
  return requestMethod(apiServices.projectDuplicateAPI(data))
    .then(response => {
      return {
        data: get(response, "data.data"),
        status: get(response, "data.status"),
        message: get(response, "data.message")
      };
    })
    .catch(e => {
      return e;
    });
};

export const shouldDeletePPAction = (
  data,
  projectId,
  requestMethod = request
) => {
  return requestMethod(apiServices.deletePP(data, projectId))
    .then(response => {
      return {
        data: get(response, "data.data"),
        status: get(response, "data.status"),
        message: get(response, "data.message")
      };
    })
    .catch(e => {
      return e;
    });
};

export const getAutoCompleteListAction = (requestMethod = request, params) => {
  return requestMethod(apiServices.getAutoCompleteList(params))
    .then(response => {
      return {
        data: get(response, "data.data"),
        status: get(response, "data.status"),
        message: get(response, "data.message")
      };
    })
    .catch(() => {});
};

export const getAutoCompleteListUserAction = (
  requestMethod = request,
  params
) => {
  return requestMethod(apiServices.getAutoCompleteListUsers(params))
    .then(response => {
      return {
        data: get(response, "data.data"),
        status: get(response, "data.status"),
        message: get(response, "data.message")
      };
    })
    .catch(() => {});
};

export const getDistrictListForLocation = (requestMethod = request, id) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.GET_DISTRICT_LIST_FOR_LOCATION_START
    });
    return requestMethod(apiServices.getStateDistrict(id))
      .then(response => {
        dispatch({
          type: CREATE_PROJECT_ACTION.GET_DISTRICT_LIST_FOR_LOCATION_SUCCESS,
          payload: get(response, "data.data")
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(err => {
        dispatch({
          type: CREATE_PROJECT_ACTION.GET_DISTRICT_LIST_FOR_LOCATION_FAILURE
        });
      });
  };
};

export const getCircleListForLocation = (requestMethod = request, id) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.GET_CIRCLE_LIST_FOR_LOCATION_START
    });
    return requestMethod(apiServices.getDistrictCircle(id))
      .then(response => {
        dispatch({
          type: CREATE_PROJECT_ACTION.GET_CIRCLE_LIST_FOR_LOCATION_SUCCESS,
          payload: get(response, "data.data")
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(err => {
        dispatch({
          type: CREATE_PROJECT_ACTION.GET_CIRCLE_LIST_FOR_LOCATION_FAILURE
        });
      });
  };
};
export const getGroupByCategoryAndParentId = (
  requestMethod = request,
  params
) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.GET_GROUP_BY_CATEGORY_AND_PARENT_ID_START
    });
    return requestMethod(apiServices.getGroupByCategoryAndParentId(params))
      .then(response => {
        dispatch({
          type:
            CREATE_PROJECT_ACTION.GET_GROUP_BY_CATEGORY_AND_PARENT_ID_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type:
            CREATE_PROJECT_ACTION.GET_GROUP_BY_CATEGORY_AND_PARENT_ID_FAILURE
        });
      });
  };
};

export const createMilestoneAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.CREATE_NEW_MILESTONE_START
    });
    return requestMethod(apiServices.createNewMilestone(params))
      .then(response => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CREATE_NEW_MILESTONE_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CREATE_NEW_MILESTONE_FAILURE
        });
      });
  };
};

export const saveNewMilestoneAction = params => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.SAVE_NEW_MILESTONE,
      payload: params
    });
  };
};

export const deleteNewMilestoneAction = params => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.DELETE_NEW_MILESTONE,
      payload: params
    });
  };
};

export const checkIssueBeforeDeletion = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.CHECK_ISSUE_DELETION_START
    });
    return requestMethod(apiServices.checkIssueDeletion(params))
      .then(response => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CHECK_ISSUE_DELETION_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CHECK_ISSUE_DELETION_FAILURE
        });
      });
  };
};

export const checkIssueBeforeDisable = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.CHECK_ISSUE_DISABLE_START
    });
    return requestMethod(apiServices.checkIssueDisable(params))
      .then(response => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CHECK_ISSUE_DISABLE_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CHECK_ISSUE_DISABLE_FAILURE
        });
      });
  };
};

export const bucketDisableIssueCheck = (
  requestMethod = request,
  projectId,
  bucketId
) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.CHECK_ISSUE_BUCKET_DISABLE_START
    });
    return requestMethod(
      apiServices.checkIssueDisableBucket(projectId, bucketId)
    )
      .then(response => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CHECK_ISSUE_BUCKET_DISABLE_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CHECK_ISSUE_BUCKET_DISABLE_FAILURE
        });
      });
  };
};

export const getGroupRolesForUser = (groupId, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.CREATE_PROJECT_START
    });
    return requestMethod(apiServices._getGroupRolesForUser(groupId))
      .then(resp => {
        const payload = resp.data;
        const payLoadData = payload.data;
        dispatch({
          payLoadData
        });
        return payLoadData;
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CREATE_PROJECT_FAILURE
        });
      });
  };
};
export const createProjectDecisionAction = (
  requestMethod = request,
  params
) => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.CREATE_PROJECT_DECISION_START
    });
    return requestMethod(apiServices.createProjectDecision(params))
      .then(response => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CREATE_PROJECT_DECISION_SUCCESS
        });
        return response;
      })
      .catch(() => {
        dispatch({
          type: CREATE_PROJECT_ACTION.CREATE_PROJECT_DECISION_FAILURE
        });
      });
  };
};
